import Breadcrumb from 'components/commercetools-ui/molecules/Breadcrumb';
import { useProductSearchContext } from 'frontastic/tastics/products/product-list/ProductSearchContext';

export default function AmpliencePLPBreadcrumbPlaceholder() {
  try {
    // eslint-disable-next-line react-hooks/rules-of-hooks
    const { productsPaginatedResults } = useProductSearchContext();
    const breadcrumbs = productsPaginatedResults?.data?.breadcrumbs || [];

    const structuredData = {
      '@context': 'https://schema.org',
      '@type': 'BreadcrumbList',
      itemListElement: [
        {
          '@type': 'ListItem',
          position: 1,
          name: 'Home',
          item: 'https://shadesoflight.com',
        },
        ...breadcrumbs.map((breadcrumb: { label: string; slug: string }, index: number) => ({
          '@type': 'ListItem',
          position: index + 2,
          name: breadcrumb.label?.toLocaleLowerCase().replace(/\b\w/g, (char) => char.toUpperCase()),
          item:
            breadcrumb.slug && typeof breadcrumb.slug === 'string'
              ? breadcrumb.slug.startsWith('//') || breadcrumb.slug.startsWith('http')
                ? breadcrumb.slug.startsWith('//')
                  ? `https:${breadcrumb.slug}`
                  : breadcrumb.slug
                : `https://shadesoflight.com/${breadcrumb.slug}`
              : '',
        })),
      ],
    };
    return <Breadcrumb breadcrumbs={breadcrumbs} structuredData={structuredData} />;
  } catch (error) {
    // Context will not be initialized if the component is rendered in Amplience Visualization mode
    return (
      <Breadcrumb
        breadcrumbs={[
          { label: 'Breadcumbs', slug: '/' },
          { label: 'PLP', slug: '/' },
          { label: 'Placeholder', slug: '/' },
        ]}
      />
    );
  }
}
